import * as api from '../utils/api';

// Billing addresses CRUD — mirrors the /clients/:id/sources (payment cards)
// pattern. Contract locked against the api repo (ticket #16): base path is
// `/clients/{id}/billing-addresses`, structured fields, server-side default
// management.
const base = (clientId) => `/clients/${clientId}/billing-addresses`;

export function getBillingAddresses(clientId) {
  return api.get(base(clientId));
}

// create/update resolve `{ status, body }` so the form can tell an expired
// session from a validation or server error.
export function createBillingAddress(clientId, payload) {
  return api.postWithStatus(base(clientId), payload);
}

export function updateBillingAddress(clientId, id, payload) {
  return api.putWithStatus(`${base(clientId)}/${id}`, payload);
}

export function deleteBillingAddress(clientId, id) {
  return api.del(`${base(clientId)}/${id}`);
}

export function setDefaultBillingAddress(clientId, id) {
  return api.put(`${base(clientId)}/${id}/default`);
}
